import { GripVertical, Trash2 } from 'lucide-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export function SortablePipelinePhaseRow({
  id,
  index,
  phase,
  inputClassName,
  canRemove,
  onChange,
  onRemove,
}: {
  id: string;
  index: number;
  phase: string;
  inputClassName: string;
  canRemove: boolean;
  onChange: (index: number, value: string) => void;
  onRemove: (index: number) => void;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 2 : undefined,
    opacity: isDragging ? 0.92 : 1,
  };
  return (
    <li
      ref={setNodeRef}
      style={style}
      className="flex flex-wrap items-center gap-2.5 py-1.5 bg-app-surface"
    >
      <button
        type="button"
        className="shrink-0 p-1.5 rounded-md text-slate-400 hover:text-app-text-muted hover:bg-app-hover cursor-grab active:cursor-grabbing touch-none"
        title="Ziehen zum Sortieren"
        aria-label="Reihenfolge per Ziehen ändern"
        {...attributes}
        {...listeners}
      >
        <GripVertical className="w-4 h-4" strokeWidth={2} />
      </button>
      <input
        type="text"
        value={phase}
        onChange={(e) => onChange(index, e.target.value)}
        maxLength={120}
        className={`flex-1 min-w-[10rem] ${inputClassName}`}
        placeholder="Phasenname"
      />
      <button
        type="button"
        title="Phase entfernen"
        disabled={!canRemove}
        className="p-1.5 rounded-lg text-slate-400 hover:bg-red-50 hover:text-red-600 shrink-0 disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-slate-400"
        onClick={() => onRemove(index)}
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </li>
  );
}
